import { useEffect, useState, useCallback, useRef } from 'react';

export function useVersionCheck() {
  const [updateAvailable, setUpdateAvailable] = useState(false);
  const buildVersion = useRef(null);

  const check = useCallback(async () => {
    try {
      const res = await fetch('/version.json?t=' + Date.now());
      if (!res.ok) return;
      const data = await res.json();
      if (!buildVersion.current) {
        buildVersion.current = data.v;
      } else if (data.v !== buildVersion.current) {
        setUpdateAvailable(true);
      }
    } catch {
      // offline or fetch failed — ignore
    }
  }, []);

  // Capture current version on mount
  useEffect(() => { check(); }, [check]);

  // Check on tab refocus only
  useEffect(() => {
    const onVisible = () => {
      if (document.visibilityState === 'visible') check();
    };
    document.addEventListener('visibilitychange', onVisible);
    return () => document.removeEventListener('visibilitychange', onVisible);
  }, [check]);

  const reload = () => window.location.reload();

  return { updateAvailable, reload };
}
